// ABOUTME: The composer's right-hand button while the field is empty: starts a live (spoken)
// conversation with the agent, the way ChatGPT's voice-mode button does. Text or an attachment
// swaps it for Send in the same place.
import { AudioLines } from 'lucide-react'
import { ComposerButton } from '@/components/ui/pill-composer'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

export function LiveConversationButton({
  onClick,
  disabled,
}: {
  onClick: () => void
  disabled?: boolean
}) {
  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>
        <ComposerButton
          tone="solid"
          onClick={onClick}
          disabled={disabled}
          aria-label="Start live conversation"
          data-testid="live-conversation-button"
        >
          <AudioLines />
        </ComposerButton>
      </TooltipTrigger>
      <TooltipContent side="top">Live conversation</TooltipContent>
    </Tooltip>
  )
}
